import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  PaginationItem,
  Pagination,
  Alert,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState, useRef } from "react";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomTextField from "../CustomComponents/CustomTextField";
import "./Accrual.css";
import StlapFooter from "../CustomComponents/StlapFooter";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import AccrualCardItems from "./AccrualCardItems";
import AccrualRemark from "./AccrualRemark";
import axios from "axios";
import { BranchAction } from "../Store/Branch";
import { useDispatch } from "react-redux";
import CustomSnackBar from "../CustomComponents/CustomSnackBar";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import { makeStyles } from "@mui/styles";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
var deductionsInitialState = {
  paidTotal: 0,
  dueTotal: 0,
  deductionTotal: 0,
  waivedTotal: 0,
  totalDeductionsTotal: 0,
};
const useStyles = makeStyles({
  dataGridContainer: {
    cursor: "pointer",
  },
});
const AdditionalWaiver = () => {
  const dispatch = useDispatch();
  const [customerDetails, setCustomerDetails] = useState({});
  const [modifiedMaps, setModifiedmap] = React.useState({});
  const [pageSize, setPageSize] = useState(10);
  const [girdVisible, setGridVisible] = useState("none");
  const [applicationSearchDisable, setApplicationSearchDisable] =
    useState(true);
  const [rows, setRows] = React.useState([]);
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);
  const [branchName, setBranchName] = useState("");
  const rowsPerPage = 10;
  const [page, setPage] = React.useState(1);
  const [accordianOpen, setAccordianOpen] = React.useState(true);
  const [gridAlert, setGridAlert] = useState("none");
  const [reason, setReason] = useState("");
  const [historyData, setHistorydata] = useState({});
  const [remark, setRemark] = useState("");
  const [gridData, setGridData] = useState([]);
  const [updateDisable, setUpdateDisable] = useState(true);
  const [deductionsState, setDeductionsState] = useState(
    deductionsInitialState
  );
  const [branchNameValue, setBranchNameValue] = useState("");
  const [discardOpen, setDiscardOpen] = useState(false);
  const [applicationNumberModifiedValue, setApplicationNumberModifiedValue] =
    useState("");
  const [lengthError, setLengthError] = useState(false);
  const [firstCharError, setFirstCharError] = useState(false);
  const [minLetterError, setMinLetterError] = useState(false);
  const [remarkError, setRemarkError] = useState(false);
  const [reasonError, setReasonError] = useState(false);
  const [codeMap, setCodeMap] = useState({});
  //shortcut keys
  const searchButtonRef = useRef(null);
  const clearRef = useRef(null);
  const goButtonRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keyup", onKeyPressEventHandler);
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    return () => {
      window.removeEventListener("keyup", onKeyPressEventHandler);
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    dispatch(
      CommonShortCutAction.removeDefaultShortCutValue({
        event: event,
        screen: "accuralWaiver",
      })
    );
  };
  const onKeyPressEventHandler = (event) => {
    let refList = {
      searchButtonRef: searchButtonRef,
      goButtonRef: goButtonRef,
      clearRef: clearRef,
    };
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.getShortCutValue({
          event: event,
          refs: refList,
          screen: "accuralWaiver",
        })
      );
    }
  };

  const handleSearch = (event) => {
    event.preventDefault();
    if (branchName && applicationNum) {
      getData();
      setGridVisible("block");
    } else {
      branchName ? setBranchNameNotValid(false) : setBranchNameNotValid(true);
      applicationNum
        ? setapplicationNumNotValid(false)
        : setapplicationNumNotValid(true);
      setGridVisible("none");
    }
  };
  const getData = async () => {
    try {
      setGridLoading(true);
      const response = await axios.post("/additionalfee/getFeeData", {
        applicationNum: applicationNum,
        type: "waiver",
      });
      setCodeMap(response.data.codeMap);
      setDataRow(response.data.gridData);
      getDataCount(response.data.gridData);
      setGridData(response.data.gridData);
      setPage(0);
      setReferenceNumber(
        response.data.referenceNumber ? response.data.referenceNumber + 1 : 1
      );
      setModifiedmap(getModifiedData(response.data.gridData));
      setReason("");
      setRemark("");
      setUpdateDisable(true);
      setGridVisible("block");
      setGridLoading(false);
    } catch {
      setGridVisible("none");
      setGridLoading(false);
      console.log("Network Error");
    }
  };
  const getDataCount = (gridRows) => {
    let paidTotal1 = 0;
    let dueTotal1 = 0;
    let deductionTotal1 = 0;
    let waivedTotal1 = 0;
    let data = { ...deductionsInitialState };
    gridRows.map((rows) => {
      data = {};
      paidTotal1 = paidTotal1 + rows.received;
      dueTotal1 = dueTotal1 + rows.receiveable + rows.additionalAccrual;
      deductionTotal1 =
        deductionTotal1 +
        rows.additionalAccrual +
        (rows.receiveable -
          rows.received -
          rows.earlyWaiver -
          rows.additionalWaiver);
      waivedTotal1 = waivedTotal1 + rows.earlyWaiver;
      data.paidTotal = paidTotal1;
      data.dueTotal = dueTotal1;
      data.deductionTotal = deductionTotal1;
      data.waivedTotal = waivedTotal1;
      data.totalDeductionsTotal =
        dueTotal1 + deductionTotal1 - paidTotal1 - waivedTotal1;
    });
    setDeductionsState(data);
  };
  const [branchNameNotValid, setBranchNameNotValid] = useState(false);
  const [applicationNumNotValid, setapplicationNumNotValid] = useState(false);
  const onChangeCardItems = (row, value) => {
    row["waived"] = value;
    setDataRow((oldArray) => [...oldArray, row]);
  };
  useEffect(() => {
    setRows(dataRows.slice(0, rowsPerPage));
    setTotalPageCount(
      dataRows.length % 10 !== 0
        ? Number(Number((dataRows.length / 10).toFixed()) + 1)
        : Number(Number((dataRows.length / 10).toFixed()))
    );
    setTotalRowsCount(dataRows.length);
    const branchValues = GetBranchDetails();
    setbranchNames(branchValues);
  }, []);
  const getModifiedData = (modifiedData) => {
    let modifiedMap = {};
    modifiedData.forEach(function (key) {
      modifiedMap[key["id"]] = key["additionalWaiver"];
    });
    return modifiedMap;
  };

  const [snackBarMessage, setSnackBarMessage] = useState(
    "Amount should not exceed 9,99,99,999 / decimal value not acceptable"
  );
  const [snackBarValidationMessage, setSnackBarValidationMessage] = useState(
    " Additional Waiver amount should not exceed amount"
  );
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState(0);
  const [currentDate, setCurrentDate] = useState(
    new Date(
      `${new Date().getFullYear()}/${
        new Date().getMonth() + 1
      }/${new Date().getDate()}`
    ).toLocaleDateString("fr-FR")
  );
  const [applicationNum, setapplicationNum] = useState("");
  const [applicationNumList, setapplicationNumList] = useState([]);
  const [isClearButtonClicked, setIsClearButtonClicked] = useState(false);
  const discardChanges = () => {
    setUpdateDisable(true);
    setDataRow([]);
    setHistorydata([]);
    applicationNumberModifiedValue && applicationNumberModifiedValue.label
      ? setapplicationNum(applicationNumberModifiedValue.label)
      : setapplicationNum("");
    dispatch(BranchAction.updateInitialLoad(false));
    if (branchNameValue && branchNameValue.label) {
      setBranchName(branchNameValue.label);
      dispatch(BranchAction.updateHeaderBranchDetails(branchNameValue.label));
      getApplicationListData(branchNameValue);
    }
    branchNameValue && branchNameValue.label
      ? setBranchName(branchNameValue.label)
      : branchName
      ? setBranchName(branchName.label ? branchName : branchName.label)
      : setBranchName("");
    setReferenceNumber("");
    setGridVisible("none");
    setReason("");
    setRemark("");
    if (isClearButtonClicked || branchNameValue === null) {
      setIsClearButtonClicked(false);
      setBranchName("");
    }
    if (branchNameValue === null) {
      setapplicationNum("");
      setapplicationNumList([]);
    }
    setDiscardOpen(false);
    clearRemarkError();
  };

  const clearRemarkError = () => {
    setRemarkError(false);
    setLengthError(false);
    setFirstCharError(false);
    setMinLetterError(false);
    setReasonError(false);
  };

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const getcustomerDetails = async (value) => {
    const branchCodeValue = getSelectedBranchCode(branchName.label);
    const response = await axios.post(
      "/losCustomer/getLosDetailsByBranchAndAppNum",
      {
        branchName: branchName.label,
        appNum: value.value,
        branchCode: branchCodeValue,
      }
    );
    setCustomerDetails(response.data);
  };
  const onChangeForReferenceEvent = (event, newValue) => {
    if (newValue.value !== null || newValue.value !== "") {
      getcustomerDetails(newValue);
    }
    if (updateDisable && !reason && !remark) {
      if (newValue === null) {
        setapplicationNum("");
        setReferenceNumber("");
        setGridVisible("none");
      } else {
        setapplicationNumNotValid(false);
        setapplicationNum(newValue.label);
      }
    } else {
      setApplicationNumberModifiedValue(newValue);
      setDiscardOpen(true);
    }
    clearRemarkError();
  };
  const handleCellChangedEvent = (event, value) => {
    var selectedValue = event.value ? event.value : 0;
    let tempValue = { ...historyData };
    const dataMap1 = [];
    var feeName = event.row ? event.row.id : event.id;
    var validValue =
      dataRows[event.id].receiveable -
        dataRows[event.id].received -
        dataRows[event.id].earlyWaiver >=
        selectedValue && !selectedValue.toString().includes(".");
    dataRows.forEach((value, index) => {
      if (value.id === feeName && validValue) {
        value.additionalWaiver = selectedValue > 0 ? selectedValue : 0;
        if (
          selectedValue &&
          selectedValue > 0 &&
          modifiedMaps[event.id] !== selectedValue
        ) {
          tempValue[value.code] = selectedValue > 0 ? selectedValue : 0;
        } else {
          tempValue[value.code] = 0;
        }
      }
      dataMap1.push(value);
    });
    setHistorydata(tempValue);
    setDataRow(dataMap1);
    // gridvalidationErrorFlag
    let gridValidationErrorFlag = false;
    if (
      selectedValue > -1 &&
      selectedValue <= 99999999 &&
      validValue &&
      !selectedValue.toString().includes(".")
    ) {
      getDataCount(dataMap1);
    } else {
      if (selectedValue < 0) {
        gridValidationErrorFlag = true;
        setSnackBarMessage("Amount should not be below 0.");
      } else if (selectedValue > 99999999) {
        gridValidationErrorFlag = true;
        setSnackBarMessage("Amount should not be exceed 9,99,99,999.");
      } else if (selectedValue.toString().includes(".")) {
        gridValidationErrorFlag = true;
        setSnackBarMessage("Decimal value is not acceptable.");
      } else if (
        dataRows[event.id].receiveable -
          dataRows[event.id].received -
          dataRows[event.id].earlyWaiver <=
        selectedValue
      ) {
        gridValidationErrorFlag = true;
        setSnackBarMessage(
          "Amount should not be greater than Outstanding Amount."
        );
      }
      setShowSnackBar(true);
    }

    setUpdateDisable(
      gridValidationErrorFlag ||
        !(selectedValue && modifiedMaps[event.id] !== value)
    );
    // setGridAlert("flex");
  };
  const getApplicationListData = async (branch) => {
    try {
      const branchCodeValue = getSelectedBranchCode(branch.label);
      const response = await axios.post("/additionalfee/getApplicationNumber", {
        branchName: branch.label,
        branchCode: branchCodeValue,
      });
      setapplicationNumList(response.data);
    } catch {
      setGridVisible("none");
      console.log("Network Error");
    }
  };
  const [branchNames, setbranchNames] = useState([]);
  const searchButtonClickHandler = (event) => {
    // event.preventDefault();
    // props.onSearchButtonClick(branch, trnNo, true);
  };
  const onChangeForBranchEvent = (event, newValue) => {
    if (updateDisable && !reason && !remark) {
      setBranchName(newValue);
      getApplicationListData(newValue);
      if (newValue && newValue.label) {
        dispatch(BranchAction.updateInitialLoad(false));
        dispatch(BranchAction.updateHeaderBranchDetails(newValue.label));
      } else {
        setapplicationNumList([]);
      }
      setApplicationSearchDisable(false);
      setApplicationNumberModifiedValue("");
      setBranchNameNotValid(false);
      setapplicationNum("");
      setGridVisible("none");
    } else {
      setApplicationNumberModifiedValue("");
      setBranchNameValue(newValue);
      setDiscardOpen(true);
    }
    // setApplicationSearchDisable(newValue ? false : true);
    setReferenceNumber("");
  };

  const clearButtonClickHandler = () => {
    if (updateDisable && !reason && !remark) {
      setBranchName("");
      setUpdateDisable(true);
      setapplicationNum("");
      setGridVisible("none");
      setReferenceNumber("");
      setapplicationNumNotValid(false);
      setBranchNameNotValid(false);
      setApplicationSearchDisable(true);
      setDataRow([]);
      setHistorydata([]);
      setRemark("");
      setRemarkError("");
      setReason("");
      setReasonError("");
      setCustomerDetails({});
    } else {
      setIsClearButtonClicked(true);
      setDiscardOpen(true);
    }
  };

  const [dataRows, setDataRow] = React.useState([]);
  const [gridLoading, setGridLoading] = React.useState(false);
  const columns = [
    {
      field: "details",
      headerName: "Fee Description",
      headerAlign: "center",
      type: "string",
      hideable: false,
      sortable: false,
      flex: 310,
      align: "left",
      editable: false,
    },

    {
      field: "receiveable",
      headerName: "Amount Receivable (₹)",
      headerAlign: "center",
      type: "number",
      hideable: false,
      sortable: false,
      flex: 250,
      align: "right",
      editable: false,
    },

    {
      field: "received",
      headerName: "Amount Received (₹)",
      headerAlign: "center",
      type: "number",
      flex: 150,
      align: "right",
      editable: false,
    },
    {
      field: "earlyWaiver",
      headerName: "Earlier Waiver (₹)",
      headerAlign: "center",
      type: "number",
      flex: 190,
      align: "right",
      editable: false,
    },

    {
      field: "outstanding",
      headerName: "Outstanding Amount (₹)",
      headerAlign: "center",
      type: "number",
      flex: 200,
      editable: false,
      align: "right",
      editable: false,
      valueGetter: (param) => {
        if (
          param.row.receiveable -
            param.row.received -
            param.row.additionalWaiver -
            param.row.earlyWaiver >
            0 &&
          param.row.additionalWaiver > 0 &&
          param.row.additionalWaiver <= 99999999
        ) {
          return (
            param.row.receiveable -
            param.row.received -
            param.row.additionalWaiver -
            param.row.earlyWaiver
          );
        } else {
          return (
            param.row.receiveable - param.row.received - param.row.earlyWaiver
          );
        }
      },
    },
    {
      field: "additionalWaiver",
      headerName: "Fees to be Waiver (₹)",
      headerAlign: "center",
      type: "number",
      flex: 200,
      align: "right",
      editable: true,
      valueGetter: (value) => {
        if (value.value <= 0 || value.value > 99999999) {
          // setShowSn\ackBar(true);
          return 0;
        } else {
          return value.value;
        }
      },
    },
  ];
  const handlePageChange = (event, newPage) => {
    let offset = (newPage - 1) * rowsPerPage;
    setPage(newPage);
    setRows(dataRows.slice(offset, offset + rowsPerPage));
  };
  let visibility = {
    due: false,
    paid: false,
    waived: false,
    deduction: false,
  };
  if (window.innerWidth > 700) {
    visibility = {};
  }
  const classes = useStyles();
  return (
    <div>
      <div style={{ minHeight: "calc(100vh - 108px)" }}>
        <Grid
          container
          spacing={2}
          // columns={{ xs: 1, sm: 2, md: 3, lg: 6, xl: 6 }}
          sx={{
            width: "calc(100% - 8px)",
            margin: "unset",
          }}
        >
          <AccordianContainer
            id="accord"
            title="Fee Waiver Details"
            initialOpen={true}
          >
            <Box
              id="accord-box"
              component="form"
              validate="true"
              onSubmit={searchButtonClickHandler}
              sx={{ margin: "8px 8px 0px 8px !important" }}
            >
              <Grid
                item
                container
                spacing={1}
                sx={{
                  marginTop: "-46px !important",
                  marginLeft: "-15px !important",
                }}
              >
                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                  <CustomAutoComplete
                    required={true}
                    label="Branch"
                    id="applicantName"
                    variant="standard"
                    value={branchName}
                    onChange={(event, newValue) =>
                      onChangeForBranchEvent(event, newValue)
                    }
                    type="text"
                    placeholder="Branch"
                    autoCompleteValues={branchNames}
                  />
                  {branchNameNotValid && (
                    <p className="error">Please Select Branch</p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                  <CustomAutoComplete
                    required={true}
                    disabled={branchName === null || branchName === ""}
                    // disabled={applicationSearchDisable}
                    value={applicationNum}
                    label="Application Number"
                    id="applicantName"
                    variant="standard"
                    onChange={(event, newValue) =>
                      onChangeForReferenceEvent(event, newValue)
                    }
                    // value={applicantName}
                    type="text"
                    placeholder="Application Number"
                    autoCompleteValues={applicationNumList}
                  />
                  {applicationNumNotValid && (
                    <p className="error">Please Select Application Number</p>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                  <CustomTextField
                    disabled={true}
                    label="Customer ID"
                    id="id"
                    type="text"
                    placeholder="Customer ID"
                    variant="standard"
                    value={
                      Object.keys(customerDetails).length > 0
                        ? customerDetails?.customerId
                        : ""
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                  <CustomTextField
                    disabled={true}
                    label="Applicant Name"
                    id="name"
                    type="text"
                    placeholder="Applicant Name"
                    variant="standard"
                    value={
                      Object.keys(customerDetails).length > 0
                        ? customerDetails?.customerName
                        : ""
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                  <CustomTextField
                    disabled={true}
                    label="Reference Number"
                    id="refno"
                    type="text"
                    placeholder="Reference Number"
                    required={false}
                    variant="standard"
                    value={referenceNumber === 0 ? "" : referenceNumber}
                    // onChange={trnNoChangeHandler}
                    // onChange={(event)=>setReferenceName(event.target.value)}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                  <CustomTextField
                    required={false}
                    disabled={true}
                    label="Reference Date"
                    id="refdate"
                    value={currentDate}
                    type="text"
                    placeholder=""
                    variant="standard"
                    // type="text"
                    // onChange={()=>set}
                  />
                </Grid>
              </Grid>
              <Box
                sx={{
                  margin: "8px 0px 4px 0px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Tooltip title="Ctrl+F" placement="top">
                  <Button
                    sx={{ fontWeight: "bold", height: "2rem" }}
                    variant="contained"
                    type="submit"
                    onClick={(event) => handleSearch(event)}
                    ref={searchButtonRef}
                  >
                    Search
                  </Button>
                </Tooltip>
                <Tooltip title="Ctrl+D" placement="top">
                  <Button
                    sx={{
                      marginLeft: "8px",
                      color: "white",
                      backgroundColor: "black",
                      fontWeight: "bold",
                      height: "2rem",
                    }}
                    onMouseOver={({ target }) => {
                      target.style.backgroundColor = "black";
                      target.style.color = "white";
                    }}
                    variant="contained"
                    onClick={() => clearButtonClickHandler()}
                    ref={clearRef}
                  >
                    Clear
                  </Button>
                </Tooltip>
              </Box>
            </Box>
          </AccordianContainer>
        </Grid>
        <div
          style={{
            display: girdVisible,
            width: "calc(100% - 8px)",
            paddingTop: "8px",
          }}
        >
          {useMediaQuery("(min-width:1200px)") && (
            <AccordianContainer
              id="accord"
              title="Waiver Details"
              initialOpen={true}
              sx={{ marignBottom: "8px !important" }}
            >
              <Grid container spacing={0}>
                <Grid item xs={12} sm={5} md={4} lg={2.4} xl={3}>
                  <label
                    style={{
                      fontWeight: "bold",
                      marginLeft: "8px",
                      color: "#2F7DC4",
                    }}
                  >
                    {"Total Outstanding (₹): "}
                    <span style={{ color: "#2F7DC4" }}>
                      {parseInt(deductionsState.deductionTotal).toLocaleString(
                        "en-IN"
                      )}
                    </span>
                  </label>
                </Grid>
                <Grid item xs={12} sm={5} md={4} lg={2.4} xl={3}>
                  <label
                    style={{
                      fontWeight: "bold",
                      marginLeft: "8px",
                      color: "#2F7DC4",
                    }}
                  >
                    {"Receivable (₹): "}
                    <span style={{ color: "#2F7DC4" }}>
                      {parseInt(deductionsState.dueTotal).toLocaleString(
                        "en-IN"
                      )}
                    </span>
                    {``}
                  </label>
                </Grid>
                <Grid item xs={12} sm={5} md={4} lg={2.4} xl={3}>
                  <label
                    style={{
                      fontWeight: "bold",
                      marginLeft: "8px",
                      color: "#2F7DC4",
                    }}
                  >
                    {"Received (₹): "}
                    <span style={{ color: "#2F7DC4" }}>
                      {parseInt(deductionsState.paidTotal).toLocaleString(
                        "en-IN"
                      )}
                    </span>
                    {``}
                  </label>
                </Grid>

                <Grid item xs={12} sm={5} md={4} lg={2.4} xl={3}>
                  <label
                    style={{
                      fontWeight: "bold",
                      marginLeft: "8px",
                      color: "#2F7DC4",
                    }}
                  >
                    {"Early Waived (₹): "}
                    <span style={{ color: "#2F7DC4" }}>
                      {parseInt(deductionsState.waivedTotal).toLocaleString(
                        "en-IN"
                      )}
                    </span>
                    {``}
                  </label>
                </Grid>
                <Grid item xs={12} sm={5} md={4} lg={2.4} xl={3}>
                  <label
                    style={{
                      fontWeight: "bold",
                      marginLeft: "8px",
                      color: "#2F7DC4",
                    }}
                  >
                    {"Outstanding (₹): "}
                    <span style={{ color: "#2F7DC4" }}>
                      {parseInt(deductionsState.deductionTotal).toLocaleString(
                        "en-IN"
                      )}
                    </span>
                  </label>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={2}
                // columns={{ xs: 1, sm: 2, md: 3, lg: 6, xl: 6 }}
                sx={{
                  width: "calc(100% - 8px)",
                  margin: "unset",
                  display: girdVisible,
                  backgroundColor: "#fff",
                }}
              >
                <div className={classes.dataGridContainer}>
                  <DataGrid
                    sx={{
                      boxShadow: 2,
                      border: 2,
                      minHeight: "305px",
                      borderColor: "white",
                      "& .MuiDataGrid-columnHeaders": {
                        color: "white",

                        backgroundColor: "#004A92",
                      },
                    }}
                    id="feedatagrid"
                    rowHeight={40}
                    page={page}
                    headerHeight={48}
                    loading={dataRows.length === 0 || gridLoading}
                    rows={dataRows}
                    columns={columns}
                    pageSize={pageSize}
                    disableSelectionOnClick
                    autoHeight
                    onCellEditStart={(params, event) => {
                      if (params.field === "additionalWaiver") {
                        setUpdateDisable(true);
                      }
                    }}
                    onCellClick={(params, event) => {
                      if (params.field === "additionalWaiver") {
                        setUpdateDisable(true);
                      }
                    }}
                    onCellDoubleClick={(params, event) => {
                      if (params.field === "additionalWaiver") {
                        setUpdateDisable(true);
                      }
                    }}
                    onCellEditCommit={(event, value) => {
                      handleCellChangedEvent(event, value);
                    }}
                    getRowClassName={(params) =>
                      params.id % 2
                        ? `super-app-theme--even`
                        : `super-app-theme--odd`
                    }
                    onCellKeyDown={(event, param) => {
                      (param.key === "e" || param.key === "E") &&
                        param.preventDefault();
                      // if (
                      //   (param.ctrlKey || param.metaKey) &&
                      //   param.keyCode == 86
                      // ) {
                      //   param.preventDefault();
                      // }
                    }}
                    onPageChange={(event) => setPage(event)}
                    isCellEditable={(param) =>
                      param.row.receiveable -
                        param.row.received -
                        param.row.earlyWaiver !==
                      0
                    }
                    initialState={{
                      columns: {
                        columnVisibilityModel: {
                          ...visibility,
                        },
                      },
                    }}
                  />
                </div>
              </Grid>
            </AccordianContainer>
          )}
          {useMediaQuery("(max-width:1200px)") && (
            <React.Fragment>
              <Grid
                container
                item
                direction="row"
                alignItems="flex-end"
                justifyContent="flex-end"
                sx={{ height: "60px", bgcolor: "white" }}
              >
                {totalRowsCount > 10 && (
                  <Typography
                    sx={{
                      mr: 2,
                      color: "#004A92",
                      fontWeight: 700,
                    }}
                  >
                    {"Page Max Records : " + rowsPerPage}
                  </Typography>
                )}
                <Typography
                  padding="1px"
                  sx={{
                    color: "#004A92",
                    fontWeight: 700,
                  }}
                >
                  {"Total Records : " + totalRowsCount}
                </Typography>
                <Pagination
                  count={totalPageCount}
                  color="primary"
                  onChange={handlePageChange}
                  page={page}
                  renderItem={(item) => (
                    <PaginationItem
                      slots={{ previous: ArrowBack, next: ArrowForward }}
                      {...item}
                    />
                  )}
                />
              </Grid>
              <Grid container>
                <Box
                  sx={{
                    height: accordianOpen
                      ? window.innerHeight - 540
                      : window.innerHeight - 250,
                    overflow: "auto",
                    flex: "1 auto",
                  }}
                >
                  {dataRows.map((row, index) => (
                    <AccrualCardItems
                      value={row}
                      index={index}
                      onChange={onChangeCardItems}
                      screen="waived"
                      setGridAlert={setGridAlert}
                    ></AccrualCardItems>
                  ))}
                  {/* {rows.length === 0 && (
                  <NoDataFound
                    message={"No Disbursement Record Found."}
                    imageStyle={{
                      marginTop:
                        accordianOpen && window.innerHeight < 1000
                          ? "20px"
                          : "20%",
                    }}
                  />
                )} */}
                </Box>
              </Grid>
            </React.Fragment>
          )}
          <AccrualRemark
            name="Waived By"
            gridData={dataRows}
            codeMap={codeMap}
            refNum={referenceNumber}
            applicationNum={applicationNum}
            refDate={currentDate}
            type="waiver"
            reason={reason}
            remark={remark}
            setReason={setReason}
            setRemark={setRemark}
            remarkError={remarkError}
            minLetterError={minLetterError}
            lengthError={lengthError}
            firstCharError={firstCharError}
            setRemarkError={setRemarkError}
            setMinLetterError={setMinLetterError}
            setLengthError={setLengthError}
            setFirstCharError={setFirstCharError}
            historyData={historyData}
            setReasonError={setReasonError}
            reasonError={reasonError}
            updateDisable={updateDisable}
            discardChanges={discardChanges}
            discardOpen={discardOpen}
            setDiscardOpen={setDiscardOpen}
            message={"Additional Waiver Details Update ?"}
            girdVisible={girdVisible}
            branchName={branchName}
          ></AccrualRemark>
          <CustomSnackBar
            showSnackbar={showSnackBar}
            autoHideDuration={5000}
            onClose={() => {
              setShowSnackBar(false);
            }}
            message={snackBarMessage}
            severity="error"
          />
        </div>
      </div>
      <StlapFooter />
    </div>
  );
};
export default AdditionalWaiver;
